import { DataGrid, Column } from "devextreme-react/data-grid";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
const escapeRegex = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const HighlightText = ({ text, highlight }) => {
  if (!highlight) return <>{text}</>;

  const safeHighlight = escapeRegex(highlight); // 👈 สำคัญมาก
  const regex = new RegExp(`(${safeHighlight})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <mark key={index} style={{ backgroundColor: "#ffeb3b" }}>
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </>
  );
};

const CustomerDuplicateDatagrid = ({ USER_ROLE, data, keyword }) => {
  const navigate = useNavigate();
  return (
    <div style={{ marginTop: 10 }}>
      <div className="headSubject">Duplicate Customers</div>
      <DataGrid
        dataSource={data}
        keyExpr="CRM_CUSCODE"
        showBorders={true}
        height={600}
        allowColumnReordering={true}
        allowColumnResizing={true}
      >
        <Column
          dataField="ACTIVE_STATUS"
          caption="Status"
          width={50}
          cellRender={({ value }) => {
            console.log("ACTIVE_STATUS value:", value);
            const isActive =
              value === "Active" || value === "Y" || value === true;
            const color = isActive ? "green" : "red";
            const label = isActive ? "Active" : "InActive";

            return <span style={{ color, fontWeight: "bold" }}>{label}</span>;
          }}
        />
        <Column dataField="SMF_CUSCODE" caption="SMF Code" width={70} />
        {/* ✅ เพิ่มลิงก์ที่ชื่อ */}
        <Column
          dataField="CUSTOMER_NAME"
          caption="Name"
          width={250}
          cellRender={({ data }) => {
            const isInactive =
              data.IS_ALL_INACTIVE === 1 ||
              data.IS_ALL_INACTIVE === "1" ||
              USER_ROLE == 7 ||
              USER_ROLE == 14;

            if (isInactive) {
              return (
                <span
                  style={{
                    color: "#007bff",
                    cursor: "pointer",
                    textDecoration: "underline",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                  onClick={() =>
                    navigate(
                      `/s-crm/customer?customer_id=${data.CRM_CUSCODE}&code=${data.SMF_CUSCODE}`,
                    )
                  }
                >
                  <HighlightText
                    text={data.CUSTOMER_NAME}
                    highlight={keyword}
                  />
                  <EditIcon
                    fontSize="small"
                    sx={{
                      color: "#007bff",
                      opacity: 0.7,
                      "&:hover": { opacity: 1 },
                    }}
                  />
                </span>
              );
            }

            return (
              <HighlightText text={data.CUSTOMER_NAME} highlight={keyword} />
            );
          }}
        />

        <Column dataField="TAX_ID" caption="TAX" />
        {/* <Column
          dataField="IS_ALL_INACTIVE"
          caption="สถานะ"
          cellRender={(cellData) => {
            const value = cellData.data.IS_ALL_INACTIVE;
            if (value == 1) {
              return (
                <Button
                  text="Edit"
                  type="default"
                  stylingMode="contained"
                  icon="edit"
                />
              );
            } else {
              return <span>Active</span>; // หรือแสดงค่าอื่น ๆ ได้ เช่น "ปกติ"
            }
          }}
        /> */}
        <Column dataField="SALES_NAME" caption="Sales" width={80} />
        <Column
          dataField="CreateDate"
          caption="Create"
          width={80}
          dataType="date"
          format="dd-MMM-yyyy"
        />
        <Column
          dataField="ACTIVITY_DATE"
          caption="Last Activity"
          width={80}
          dataType="date"
          format="dd-MMM-yyyy"
        />
        <Column dataField="DECISION_MAKER" caption="Decision Maker" />
        <Column dataField="SHIPPER" caption="Shipper" />
        <Column dataField="CONSIGNEE" caption="Cnee" />
      </DataGrid>
    </div>
  );
};

export default CustomerDuplicateDatagrid;
